import { Buffer } from 'buffer'; // Automatically available in Node.js; in browsers via polyfill

const xorEncryption = (input: string): Buffer => {
    const secKey = process.env.NEXT_PUBLIC_JWT_SECRET;
    if (!secKey) {
        throw new Error("Security key is undefined or not set.");
    }

    const result = Buffer.alloc(input.length);

    for (let i = 0; i < input.length; i++) {
        const inCode = input.charCodeAt(i);
        const secCode = secKey.charCodeAt(i % secKey.length);
        result[i] = inCode ^ secCode;
    }

    return result;
};

// 🔐 Encrypt to Base64 or Hex
export const encrypt = (data: any, format: 'base64' | 'hex' = 'base64'): string => {
    try {
        const stringified = JSON.stringify(data);
        const encryptedBuffer = xorEncryption(stringified);
        return encryptedBuffer.toString(format);
    } catch (err) {
        console.error("Encryption failed:", err);
        return "";
    }
};

// 🔓 Decrypt from Base64 or Hex
export const decrypt = (encrypted: string, format: 'base64' | 'hex' = 'base64'): any => {
    try {
        const secKey = process.env.NEXT_PUBLIC_JWT_SECRET;
        if (!secKey) throw new Error("Security key is undefined or not set.");

        const buffer = Buffer.from(encrypted, format);
        const decryptedChars = [];

        for (let i = 0; i < buffer.length; i++) {
            const xorCode = buffer[i] ^ secKey.charCodeAt(i % secKey.length);
            decryptedChars.push(String.fromCharCode(xorCode));
        }

        const decryptedString = decryptedChars.join('');
        return JSON.parse(decryptedString);
    } catch (err) {
        console.error("Decryption failed:", err);
        return "";
    }
};
